import { NumberParam, useQueryParam } from 'use-query-params';
export const useQueryPage = () => {
    const [page, setPage] = useQueryParam('page', NumberParam);
    return {
        page: page || 1,
        setPage,
    };
};
